import { render, staticRenderFns } from "./color_item.vue?vue&type=template&id=8cffe9c4&"
import script from "./color_item.vue?vue&type=script&lang=js&"
export * from "./color_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports